import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* global gapi */
import React from 'react';
import { attachScript } from '../../../../../common/utils/attach-script';
import AccessibleSocialButton from './accessible-social-button';
const LIBRARY_URL = 'https://apis.google.com/js/platform.js';
export default class YoutubeButton extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init", containerNode => {
      gapi.ytsubscribe.render(containerNode, {
        channelid: this.props.cardData.id,
        count: 'hidden'
      });
      return new Promise(resolve => {
        setTimeout(resolve);
      });
    });
  }
  attachScript() {
    if (window.gapi) {
      return Promise.resolve();
    }
    return attachScript(LIBRARY_URL);
  }
  render() {
    const {
      isAccessible,
      youtubeButtonTitle
    } = this.props;
    return /*#__PURE__*/React.createElement(AccessibleSocialButton, {
      isAccessible: isAccessible,
      attachScript: this.attachScript,
      title: youtubeButtonTitle,
      initButton: this.init
    });
  }
}
//# sourceMappingURL=youtube.js.map